export default "__VITE_ASSET__BvU3Rl2E__"